module.exports = __webpack_public_path__ + "static/media/1a362321-9b78-42a4-ba60-bdc5a75479f6.0972d0af.jpg";